module.exports = __webpack_public_path__ + "img/xqh.4383c65f.jpg";